<template>
  <div class="login-wrapper">
    <div class="login-box">
      <div class="login-title">网站后台</div>
      <div class="login-subtitle">登录到管理中心</div>

      <el-form :model="form" ref="loginForm" class="login-form">
        <el-form-item prop="username">
          <el-input
            v-model="form.username"
            placeholder="账号"
            size="large"
            class="login-input"
          />
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model="form.password"
            placeholder="密码"
            type="password"
            show-password
            size="large"
            class="login-input"
          />
        </el-form-item>

        <el-button type="primary" size="large" class="login-btn" @click="handleLogin">
          <el-icon><i-ep-user /></el-icon>
          登录
        </el-button>
      </el-form>

    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue'
import { ElMessage } from 'element-plus'
import md5 from 'js-md5'
import request from '../utils/request'
import store from '../store'

const APP_ID = process.env.VUE_APP_APPID
const API_KEY = process.env.VUE_APP_APIKEY

const form = reactive({
  username: '',
  password: ''
})

const loginForm = ref(null)

const handleLogin = async () => {
  const md5Password = md5(form.password)
  const referer = window.location.origin
  const key = md5(
    form.username + md5Password + APP_ID + API_KEY + referer
  )
  try {
    const data = await request.post('/v1/admin/login', {
      username: form.username,
      referer,
      key
    })
    store.commit('setToken', data.token)
    window.location.href = '/dashboard'
  } catch (err) {
    ElMessage.error(err)
  }
}
</script>

<style scoped>
.login-wrapper {
  background-color: #f2f4f8;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-box {
  width: 400px;
  background-color: #fff;
  border-radius: 10px;
  padding: 40px 30px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.login-title {
  font-size: 28px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}

.login-subtitle {
  font-size: 14px;
  color: #888;
  margin-bottom: 30px;
}

.login-input :deep(.el-input__wrapper) {
  border-radius: 6px;
  background-color: #f5f7fa;
}

.login-btn {
  width: 100%;
  margin-top: 10px;
  border-radius: 6px;
  background-color: #096dd9;
  border-color: #096dd9;
}

</style>
